import * as React from 'react';
import MenuLoader from "./MenuLoader";
import BottomBar from './BottomBar';
import PreOrder from './PreOrder';
import SearchOrder from './SearchOrder';

class MenuPizza extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openSearchOrder: false,
      openOrder: false,
      order: [],
      orderCreated: null,
    };
  }

  setOpenOrder = (isOpen) => {
    this.setState({
      openOrder: isOpen
    });
  }

  setOrder = (order) => {
    this.setState({
      order: order
    });
  }

  setOrderCreated = (isOpen) => {
    this.setState({
      orderCreated: isOpen
    });
  }

  setOpenSearchOrder = (isOpen) => {
    this.setState({
      openSearchOrder: isOpen
    });
  }

  render() {
    const allZero = this.state.order.every(pizza => pizza.quantity === 0);
    return (
      <React.Fragment>
        <div className="Content">
          <MenuLoader
            order={this.state.order}
            setOrder={this.setOrder}
          />
        </div>
        {this.state.openOrder ?
          <PreOrder
            isOpenCart={this.state.openOrder}
            setOpenOrder={this.setOpenOrder}
            order={this.state.order}
            orderCreated={this.state.orderCreated}
            setOrder={this.setOrder}
            setOrderCreated={this.setOrderCreated}
          /> : ""}
        {this.state.openSearchOrder ?
          <SearchOrder
            isOpenSearchOrder={this.state.openSearchOrder}
            setOpenSearchOrder={this.setOpenSearchOrder}
          /> : ""}

        {/*<BottomBar
          setOpenOrder={this.setOpenOrder}
          setOpenSearchOrder={this.setOpenSearchOrder}
          allZero={allZero}
        />*/}
      </React.Fragment>
    );
  }
}

export default MenuPizza;